<template>
  <div>
    <div
      :class="display" class="drawer-backdrop">
    </div>
    <div
      :class="display" class="drawer-container">
      <slot name="body" />
    </div>
  </div>
</template>

<script lang="js">

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      display: { open: false }
    }
  },
  watch: {
    open(open) {
      this.display = { open }
    }
  },
  mounted() {
    this.display = { open: this.open }
  }
}

</script>

<style lang="css" scoped>

.drawer-backdrop,
.drawer-container {
  height  : 100svh;
  width   : 100svw;
}

.drawer-backdrop {
  background  : rgba(0, 0, 0, .5);
  position    : fixed;
  top         : 0;
  left        : 0;
  z-index     : -1;
  opacity     : 0;
  transition  : all .4s;
}

.drawer-backdrop.open {
  z-index: unset;
  opacity: 1;
}

.drawer-container {
  position          : absolute; 
  top               : 0;
  right             : -100%;
  height            : 100%;
  width             : 100%;
  max-width         : 768px;
  overflow-x        : hidden; 
  overflow-y        : auto;
  transition        : all .4s;
  background-color  : white;
}

.drawer-container.open {
  visibility  : visible;
  right       : 0; 
}

@media screen and (max-width: 768px) {
  
  .drawer-container {
    width: 100%;
  }
}

</style>